var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TaxExempt'),_c('CancelOrder'),_c('ChargeBack'),_c('AdjustPrice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }